<template>
  <div class="form-group-container">
    <div class="form-group-item">
      <FormGroup>
        <h5 class="name">วันออนแอร์ <small class="text-danger ml-auto">* ต้องระบุ</small></h5>
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-outline-dark"
            :class="{'is-selected' : isDayExsiting(indexOfDay) }"
            v-for="indexOfDay in 7"
            :key="indexOfDay"
            @click.stop="onSelected(indexOfDay)">
            {{getDay(indexOfDay)}}
          </button>
        </div>
      </FormGroup>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import dateFormetter from '@/utils/dateFormatter';
import FormGroup from '@/components/FormGroup.vue';

export default {
  mixins: [dateFormetter],
  props: {
    recurrentDaysOfWeek: {
      type: Array,
      default: () => [],
    },
    updateScheduleItemStateError: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    FormGroup,
  },
  methods: {
    isDayExsiting(indexOfDay) {
      return _.find(this.recurrentDaysOfWeek, (day) => day === indexOfDay);
    },
    onSelected(indexOfDay) {
      if (this.isDayExsiting(indexOfDay)) {
        const newPayload = _.filter(this.recurrentDaysOfWeek, (day) => day !== indexOfDay);
        this.$emit('update:recurrentDaysOfWeek', newPayload);
      } else {
        const newPayload = [...this.recurrentDaysOfWeek, indexOfDay];
        this.$emit('update:recurrentDaysOfWeek', newPayload);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';


.form-group-container {
  display: flex;

  .form-group-item {
    margin-right: $spacer * 2;

    &:last-child {
      margin-right: 0;
    }
  }
}

.btn-group {
  .btn {
    border-right-width: 0;

    &:last-child {
      border-right-width: 1px;
    }

    &.is-selected, &:hover {
      background-color: $gray-400;
      box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
    }
  }
}
</style>
